import { Video } from 'lucide-react';
import React from 'react';
import { Link } from 'react-router-dom';

function CategoryGrid() {
  return (
    <section className="category-area category-arrivals-area premium-category-section">
      <div className="container">
        <div className="row row-gutter-80 category-items-style11 align-items-start">
          
          {/* LEFT COLUMN: NEW DRESSES (Image Top, Content Bottom) */}
          <div className="col-md-6 mb-5 mb-md-0">
            <div className="category-item-lux hover-effect-lux">
              
              {/* Media Thumbnail Container with Geometric Hover Lines */}
              <div className="thumb-lux position-relative overflow-hidden">
                <Link to="/category/dresses" className="d-block w-100">
                <video
  className="fit-editorial-asset"
  loop
  muted
  playsInline
  autoPlay
  preload="auto"
  poster={`${process.env.PUBLIC_URL}/assets/videos/bag05.jpg`}
>
  <source 
    src={`${process.env.PUBLIC_URL}/assets/videos/bag05.mp4`} 
    type="video/mp4" 
  />
</video>
                </Link>
                
                {/* 🌟 THE GEOMETRIC HOVER OVERLAY SYSTEM */}
                <div className="geometric-overlay">
                  <div className="border-line line-top-left"></div>
                  <div className="border-line line-bottom-right"></div>
                </div>
              </div>

              {/* Text Content Area (Bottom Aligned) */}
              <div className="content-lux text-center mt-4">
                <h4 className="title-lux">New Dresses</h4>
                <p className="subtitle-lux">Stretch your style limits with our latest dress</p>
                <Link to="/shop" className="btn-theme-lux">
                  Shop Now
                </Link>
              </div>

            </div>
          </div>

          {/* RIGHT COLUMN: BEST SELLER (Content Top, Image Bottom) */}
          <div className="col-md-6 mt-lg-5">
            <div className="category-item-lux hover-effect-lux d-flex flex-column">
              
              {/* Text Content Area (Top Aligned) */}
              <div className="content-lux text-center mb-4 order-2 order-md-1">
                <h4 className="title-lux mt-3">Best Seller</h4>
                <p className="subtitle-lux">Stretch your style limits with our latest Collection</p>
                <Link to="/shop" className="btn-theme-lux">
                  Shop Now
                </Link>
              </div>

              {/* Media Thumbnail Container (Bottom) */}
              <div className="thumb-lux position-relative overflow-hidden order-1 order-md-2">
                <Link to="/shop" className="d-block w-100">
                  <img 
                    src={`${process.env.PUBLIC_URL}/assets/videos/woolen.jpg`}
                    className="img-fluid w-100 main-category-img" 
                    alt="Best Seller Collection"
                  />
                    
                </Link>
                
                {/* 🌟 THE GEOMETRIC HOVER OVERLAY SYSTEM */}
                <div className="geometric-overlay">
                  <div className="border-line line-top-left"></div>
                  <div className="border-line line-bottom-right"></div>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>
  );
}

export default CategoryGrid;